import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { randomId } from "@mui/x-data-grid-generator";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import {
  addDeployment,
  deleteDeployment,
  loadDeploymentList,
  setBuilding,
  setFloor,
  setProject,
  setRoom,
  updateDeployment,
  updateProject,
} from "../actions/adminAction";

// Add Functionality
function EditToolbar(props) {
  const { setRows, setRowModesModel, deploymentsList, selectedDeployments, dispatch, addDeployment } = props;

  const handleAddRecord = () => {
    const id = randomId();
    setRows((prev) => [{ id, deviceID: "", isNew: true, ...prev }]);
    setRowModesModel((prev) => ({
      ...prev,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "selectedProject" },
    }));
  };

  const handleShowAll = () => {
    if (deploymentsList && deploymentsList.data) {
      const initialRows = deploymentsList.data.map((deployment) => ({
        id: deployment.deploymentID,
        deploymentID: deployment.deploymentID,
        selectedProject: deployment.projectID,
        selectedBuilding: deployment.buildingID,
        selectedFloor: deployment.floorID,
        selectedRoom: deployment.roomID,
        selectedDevice: deployment.deviceID,
        fromDate: deployment.fromDate,
        toDate: deployment.toDate,
      }));
      setRows(initialRows);
    }
  };

  const  duplicateDeployments =() =>{
     // Check if deployment lists and selected deployment list available
    // Loop through selected deployment list and find the details from selected deployment
    let selectedDeploymentDetails;
    
    if(selectedDeployments.length){
      if(deploymentsList.data.length){
        selectedDeploymentDetails = deploymentsList.data?.filter((deployment)=>selectedDeployments.includes(deployment.deploymentID));
      }
  
      // alternative for using modal for confirmation message
      // eslint-disable-next-line no-restricted-globals
      if(confirm("Are you sure you want to duplicate the records")){
        if(selectedDeploymentDetails.length){
          selectedDeploymentDetails.map((selectedDeployment)=>{
            // Update the row on the UI
            const id = randomId();
            setRows((prev) => [
              { id, selectedProject:selectedDeployment.projectID, selectedBuilding: selectedDeployment.buildingID, selectedFloor: selectedDeployment.floorID, selectedRoom: selectedDeployment.roomID, fromDate: selectedDeployment.fromDate, toDate:selectedDeployment.toDate, selectedDevice: selectedDeployment.deviceID, isNew: true },
              ...prev,
            ]);
            setRowModesModel((prev) => ({
              ...prev,
              [id]: { mode: GridRowModes.Edit, fieldToFocus: "selectedProject" },
            }));
          })
        }
      }
    }
   else{
    alert("No deployment has been selected");
   }
  }


  return (
    <GridToolbarContainer>
      <Button color="primary" startIcon={<AddIcon />} onClick={handleAddRecord}>
        Add Deployment
      </Button>
      <Button color="primary" startIcon={<ContentCopyOutlinedIcon/> } onClick={duplicateDeployments}>
        Duplicate Deployment
      </Button>
      <Button color="primary" onClick={handleShowAll}>
        Show All
      </Button>
    </GridToolbarContainer>
  );
}

export default function DeploymentGridTable({ setActiveTab }) {
  const dispatch = useDispatch();
  const projectsList = useSelector((state) => state.admin.projectsList);
  const selectedProject = useSelector((state) => state.admin.project);
  const clientsList = useSelector((state) => state.admin.clientsList);
  const deploymentsList = useSelector((state) => state.admin.deploymentsList);
  const deployment = useSelector((state) => state.admin.deployment);
  const [selectedDeployments, setSelectedDeployments] = useState([]);
  
  const buildingsList = useSelector((state) => state.admin.buildingsList);
  const floorsList = useSelector((state) => state.admin.floorsList);
  const roomsList = useSelector((state) => state.admin.roomsList);
  const devicesList = useSelector((state) => state.admin.devicesList);
  const [deleteID, setDeleteID] = useState();
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});


   // Function to check if any row is in edit mode
   const isAnyRowInEditMode = Object.values(rowModesModel).some(
    (rowMode) => rowMode.mode === GridRowModes.Edit
  );

  // Re-render when there is update on the deployment list, on initial load and when a project is selected, load the whole deployment list, if any project is selected, show only deployment for the project
  useEffect(() => {
    // if there is selected project
    if (selectedProject && deploymentsList && deploymentsList.data) {
      const projectDeployments = deploymentsList.data.filter(
        (d) => d.projectID === selectedProject.projectID
      );

      const initialRows = projectDeployments.map((deployment) => ({
        id: deployment.deploymentID,
        deploymentID: deployment.deploymentID,
        selectedProject: deployment.projectID,
        selectedBuilding: deployment.buildingID,
        selectedFloor: deployment.floorID,
        selectedRoom: deployment.roomID,
        selectedDevice: deployment.deviceID,
        fromDate: deployment.fromDate,
        toDate: deployment.toDate,
      }));
      setRows(initialRows);
    }
    // Retrieve all the deployment lists
    else if (deploymentsList && deploymentsList.data) {
      const initialRows = deploymentsList.data.map((deployment) => ({
        id: deployment.deploymentID,
        deploymentID: deployment.deploymentID,
        selectedProject: deployment.projectID,
        selectedBuilding: deployment.buildingID,
        selectedFloor: deployment.floorID,
        selectedRoom: deployment.roomID,
        selectedDevice: deployment.deviceID,
        fromDate: deployment.fromDate,
        toDate: deployment.toDate,
      }));
      setRows(initialRows);
    }
  }, [deploymentsList.data, deployment, selectedProject]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleRowSelectionChange = (selectedRowID)=>{
    setSelectedDeployments(selectedRowID);
  }

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    dispatch(deleteDeployment(id));
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow && editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    // Condition to validate the device already attached

    // Refer ProjectGridTable for date time conversion before persist to database

    // Get the deployment device
    const selectedDevice = newRow?.selectedDevice;
    let deploymentWithSelectedDevice = {};

    // Get on-going deployment with selected device
    if (selectedDevice && deploymentsList.data) {
      deploymentWithSelectedDevice = deploymentsList.data?.filter(
        (deployment) => {
          // Check if the selected device already attached to an on-going project, "1970-01-01T00:00:00.000Z" means null
          const testTime = new Date(deployment.toDate).getTime();
          if (deployment.deviceID === selectedDevice && testTime === 0) {
            return deployment;
          }
        }
      );
    }

    // Check for the on-going project
    if (newRow.isNew) {
      dispatch(addDeployment(newRow));
      if(!isAnyRowInEditMode) dispatch(loadDeploymentList())
      return newRow;
    } else {
      const updatedRow = { ...newRow, isNew: false };
      setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

      dispatch(updateDeployment(updatedRow.deploymentID, updatedRow));

      // Double check this condition to end the deployments with same device
      // if (deploymentWithSelectedDevice.length) {
      //   alert(
      //     "The selected device has been attached to an on-going deployment"
      //   );
      //   deploymentWithSelectedDevice.map((deployment) => {
      //     dispatch(
      //       updateDeployment(deployment.deploymentID, {
      //         ...deployment,
      //         toDate: new Date().toISOString(),
      //       })
      //     );
      //   });
      // }
      if(!isAnyRowInEditMode) dispatch(loadDeploymentList())
      return updatedRow;
    }
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const deploymentColumns = [
    // {
    //   field: "deploymentID",
    //   headerName: "Deployment ID",
    //   width: 150,
    //   editable: false,
    // },
    {
      field: "selectedProject",
      headerName: "Project",
      type: "singleSelect",
      width: 150,
      editable: true,
      valueGetter: (params) => {
        const selectedProjectId = params.row.selectedProject;
        return selectedProjectId ? selectedProjectId : null;
      },
      valueOptions: projectsList.data?.map((project) => ({
        value: project.projectID,
        label: project.projectDesc,
      })),
    },
    {
      field: "selectedBuilding",
      headerName: "Building",
      type: "singleSelect",
      width: 150,
      editable: true,
      valueGetter: (params) => {
        const selectedBuildingId = params.row.selectedBuilding;
        return selectedBuildingId ? selectedBuildingId : null;
      },
      valueOptions: buildingsList?.map((building) => ({
        value: building.id,
        label: building.name,
      })),
    },
    {
      field: "selectedFloor",
      headerName: "Floor",
      type: "singleSelect",
      width: 150,
      editable: true,
      valueGetter: (params) => {
        const selectedFloorId = params.row.selectedFloor;
        return selectedFloorId ? selectedFloorId : null;
      },
      valueOptions: (params) => {
        return floorsList
          .filter((floor) => floor.buildings_id === params.row.selectedBuilding)
          .map((floor) => ({
            value: floor.id,
            label: floor.floor,
          }));
      },
    },
    {
      field: "selectedRoom",
      headerName: "Room",
      type: "singleSelect",
      width: 150,
      editable: true,
      valueGetter: (params) => {
        const selectedRoomId = params.row.selectedRoom;
        return selectedRoomId ? selectedRoomId : null;
      },
      valueOptions: (params) => {
        return roomsList
          .filter((room) => room.floors_id === params.row.selectedFloor)
          .map((room) => ({
            value: room.id,
            label: room.Room,
          }));
      },
    },
    {
      field: "fromDate",
      headerName: "From",
      type: "dateTime",
      width: 200,
      editable: true,
      valueGetter: (params) => {
        return params.value;
      },
      valueFormatter: (params) => {
        if (params.value) {
          const validDate = new Date(params.value).getTime();
          if (validDate) {
            return new Date(params.value);
          }
        }
        return "";
      },
    },
    {
      field: "toDate",
      headerName: "To",
      type: "dateTime",
      width: 200,
      editable: true,
      valueGetter: (params) => {
        return params.value;
      },
      valueFormatter: (params) => {
        if (params.value) {
          const validDate = new Date(params.value).getTime();
          if (validDate) {
            return new Date(params.value);
          }
        }
        return "";
      },
    },
    {
      field: "selectedDevice",
      headerName: "Device",
      type: "singleSelect",
      width: 150,
      editable: true,
      valueGetter: (params) => {
        const selectedDeviceId = params.row.selectedDevice;
        return selectedDeviceId ? selectedDeviceId : null;
      },
      valueOptions: (params) => {
        return devicesList.data?.map((device) => ({
          value: device.deviceID,
          label: device.title,
        }));
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "primary.main",
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              sx={{
                color: "primary.secondary",
              }}
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            data-bs-toggle="modal"
            data-bs-target="#deleteUser"
            onClick={() => setDeleteID(id)}
            sx={{
              color: "#dd3545",
            }}
          />,
        ];
      },
    },
  ];

  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
      }}
    >
      {/* Delete Modal */}
      <div
        className="modal fade"
        id="deleteUser"
        aria-labelledby="deleteUserLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content admin-list">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteUserLabel">
                Delete Deployment
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              Are you sure you want to delete deployment {`${deleteID}`}?
              <br />
              <br />
              <b>
                <span className="text-danger text-center">
                  Warning: Delete deployment will impact the data display on the
                  portal.
                </span>
              </b>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn admin-list-btn-secondary text-white"
                onClick={handleDeleteClick(deleteID)}
                data-bs-dismiss="modal"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
      {rows && rows.length > 0 && deploymentsList ? (
        <DataGrid
          sx={{
            color: "white",
            "& .MuiDataGrid-menuIconButton": {
              color: "white",
            },
            "& .MuiCheckbox-root": {
              color: "white",
            },

            "& .MuiDataGrid-sortIcon": {
              color: "white",
            },

            "& .MuiTablePagination-root": {
              bgcolor: "white",
            },
            "& .MuiDataGrid-cell": {
              border: 0,
            },
            "& .MuiDataGrid-row:hover": {
              bgcolor: "primary.main",
            },
            "& .MuiDataGrid-cell:hover": {
              bgcolor: "none",
            },
            "& .MuiDataGrid-cell:focus": {
              bgcolor: "primary.light",
            },
          }}
          rows={rows}
          columns={deploymentColumns}
          editMode="row"
          getRowId={(row) => row.id}
          // initialState={{
          //   pagination: {
          //     paginationModel: {
          //       pageSize: 5,
          //     },
          //   },
          // }}
          rowModesModel={rowModesModel}
          onRowModesModelChange={handleRowModesModelChange}
          pageSizeOptions={[5]}
          checkboxSelection
          onRowSelectionModelChange={handleRowSelectionChange}
          // disableRowSelectionOnClick
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          slots={{
            toolbar: EditToolbar,
          }}
          slotProps={{
            toolbar: { setRows, setRowModesModel, deploymentsList,selectedDeployments },
          }}
        />
      ) : (
        // <CircularProgress />
        <div>No records found</div>
      )}
    </Box>
  );
}
